import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nav-fee",
  "use": "icon-nav-fee-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-nav-fee\">\r\n<path d=\"M141.4,119.8c0-5,4-9,9-9c2.4,0,4.6,0.9,6.4,2.6c1.7,1.7,2.6,3.9,2.6,6.3v0c0,2.4-1,4.7-2.6,6.3c-1.7,1.7-4,2.6-6.4,2.6\r\n\tc-2.4,0-4.6-0.9-6.3-2.6C142.3,124.5,141.4,122.2,141.4,119.8z M143.9,139.5H200v45.1c0,8.5-7,15.4-15.5,15.4H15.5\r\n\tC7,200,0,193.1,0,184.6V64.9c0-8.5,7-15.4,15.5-15.4h169.1c8.5,0,15.5,6.9,15.5,15.4v33.9h-56.1c-8.5,0-15.5,6.9-15.5,15.4v9.9\r\n\tC128.4,132.6,135.4,139.5,143.9,139.5L143.9,139.5z M171.5,37.4H69.8l64.4-35.5c7.4-4.1,16.9-1.4,21,6L171.5,37.4z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/nav/nav-fee.svg
// module id = luYA
// module chunks = 13